import { useTranslation } from 'react-i18next';
import { useDirectReportee } from '../apps/meetings/hooks/useDirectReportee';
import { MeetingKeyResultsSection } from '../apps/meetings/components/meeting-details/MeetingKeyResultsSection';
import { MeetingObjectivesSection } from '../apps/meetings/components/meeting-details/MeetingObjectivesSection';
import { useFetchDirectReporteeObjectives } from '../apps/meetings/hooks/useFetchDirectReporteeObjectives';

export const PrintOKRSection = ({
  meeting,
  userId, 
  attendees, 
  showTeamOkrs, 
  showPersonalOkrs, 
  showKrsOnTeamOkrs
}) => {
  const { t } = useTranslation();
  const isPrint = true;
  const { 
    loadingDirectReportee,
    directReporteeId,
    managerId
  } = useDirectReportee({ attendees, userId });
  const { 
    loadingDirectReporteeObjectives,
    response 
  } = useFetchDirectReporteeObjectives({ 
    loadingDirectReportee, 
    directReporteeId,
    meetingId: meeting.id,
    isConversationTeamOkrSection: showTeamOkrs,
    isConversationPersonalOkrSection: showPersonalOkrs,
  });

  return (
    <div style={{pointerEvents: 'none'}}>
      {showTeamOkrs && (
        <MeetingObjectivesSection
          isLoadingData={loadingDirectReporteeObjectives}
          response={response} 
          directReporteeId={directReporteeId}
          label={'Team ' + t('Objectives')}
          type='team'
          open
          isPrint={isPrint}
          meeting={meeting}
        />
      )}
      {showKrsOnTeamOkrs && (
        <MeetingKeyResultsSection
          loadingDirectReportee={loadingDirectReportee}
          directReporteeId={directReporteeId}
          managerId={managerId}
          userId={userId}
          meetingId={meeting.id}
          open
          isPrint={isPrint}
          isOneOnOne={false}
        />
      )}
      {showPersonalOkrs && (
        <MeetingObjectivesSection
          isLoadingData={loadingDirectReporteeObjectives}
          response={response}
          directReporteeId={directReporteeId}
          label={'Personal ' + t('Objectives')}
          type='personal'
          open
          isPrint={isPrint}
          meeting={meeting}
        />
      )}
    </div>
    );
};
